/**
 * OrderPaymentService
 * Service for OrderPayment entity operations
 * Route: api/orderpayments
 * Controller: OrderPaymentsController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * OrderPaymentService
 * Handles order payment CRUD operations.
 * Backend now returns OrderPaymentModelView (enriched) instead of raw entities.
 * Maps to /api/orderpayments endpoint
 */
export class OrderPaymentService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? OrderPaymentService.DEFAULT_SERVICE_PATH,
            basePath: OrderPaymentService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== QUERY BY ORDER ====================
    /**
     * Get order payments by order ID
     * GET /api/orderpayments?orderId={orderId}
     */
    async getByOrderId(orderId) {
        const response = await this.getByOrderIdRaw(orderId);
        return response.data ?? [];
    }
    /**
     * Get order payments by order ID (raw)
     */
    getByOrderIdRaw(orderId) {
        const url = this.buildUrl(`?orderId=${orderId}`);
        return this.http.get(url);
    }
    // ==================== STORE ADMIN — list view ====================
    /**
     * Filtered, sorted, paged order payments with gross / fee / net totals across the
     * whole match set, not just the page.
     * POST /api/orderpayments/list-view
     */
    async listView(filter) {
        const response = await this.listViewRaw(filter);
        return (response.data ?? {
            items: [],
            totalCount: 0,
            skip: 0,
            take: 0,
            hasMore: false,
            totalGross: 0,
            totalFees: 0,
            totalNet: 0,
        });
    }
    listViewRaw(filter) {
        return this.http.post(this.buildUrl('list-view'), filter ?? {});
    }
}
OrderPaymentService.DEFAULT_SERVICE_PATH = 'orders';
OrderPaymentService.BASE_PATH = 'api/orderpayments';
//# sourceMappingURL=OrderPaymentService.js.map